(function () {
  if (customElements.get('qlf-lab-reports')) return;

  class QlfLabReports extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.groups = Array.from(this.querySelectorAll('[data-lab-group]'));
      this.search = this.querySelector('[data-lab-search]');
      this.count = this.querySelector('[data-lab-count]');
      this.empty = this.querySelector('[data-lab-empty]');
      this.results = this.querySelector('[data-lab-list]');
      this.filters = this.querySelector('[data-lab-filters]');
      this.product = this.querySelector('[data-lab-dropdown="product"]');
      this.sorte = this.querySelector('[data-lab-dropdown="sorte"]');
      this.sorteField = this.querySelector('[data-lab-field="sorte"]');
      this.flavourLimits = new Map();
      this.chargeLimits = new Map();
      this.loadMoreProducts = this.querySelector('[data-lab-load-products]');
      this.loadMoreProducts?.addEventListener('click', () => {
        this.productLimit += 10;
        this.render(true);
      });
      this.groups.forEach((group) => {
        group.querySelector('[data-lab-load-flavours]')?.addEventListener('click', () => {
          this.flavourLimits.set(group, (this.flavourLimits.get(group) || 5) + 5);
          this.render(true);
        });
        group.querySelectorAll('[data-lab-flavour]').forEach((flavour) => {
          flavour.querySelector('[data-lab-load-charges]')?.addEventListener('click', () => {
            this.chargeLimits.set(flavour, (this.chargeLimits.get(flavour) || 3) + 3);
            this.render(true);
          });
        });
      });

      this.groups.forEach((group) => {
        const head = group.querySelector('[data-lab-toggle]');
        head?.addEventListener('click', () => this.toggle(group, head.getAttribute('aria-expanded') !== 'true'));
      });
      this.search?.addEventListener('input', () => {
        this.selectedProduct = '';
        this.render();
        this.updateSuggestions();
      });
      this.initSuggestions();
      [this.product, this.sorte].forEach((dropdown) => dropdown && this.initDropdown(dropdown));
      document.addEventListener('click', (event) => {
        this.querySelectorAll('[data-lab-dropdown]').forEach((dropdown) => {
          if (!dropdown.contains(event.target)) this.closeDropdown(dropdown);
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.querySelectorAll('[data-lab-dropdown]').forEach((dropdown) => this.closeDropdown(dropdown));
      });
      this.render();
    }

    initSuggestions() {
      this.suggestions = this.querySelector('[data-lab-suggestions]');
      if (!this.suggestions || !this.search) return;
      this.clearButton = this.querySelector('[data-lab-clear]');
      this.search.addEventListener('focus', () => this.updateSuggestions());
      this.querySelectorAll('[data-lab-quick]').forEach((button) => {
        button.addEventListener('click', () => {
          this.search.value = button.dataset.labQuick;
          this.selectedProduct = '';
          this.render();
          this.search.focus();
          this.updateSuggestions();
          this.closeSuggestions();
        });
      });
      this.clearButton?.addEventListener('click', () => {
        this.search.value = '';
        this.selectedProduct = '';
        this.render();
        this.search.focus();
        this.updateSuggestions();
      });
      this.suggestions.addEventListener('mousedown', (event) => event.preventDefault());
      this.suggestions.addEventListener('click', (event) => {
        const option = event.target.closest('[role="option"]');
        if (option) this.chooseSuggestion(Number(option.dataset.index));
      });
      this.search.addEventListener('blur', () => this.closeSuggestions());
      this.search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeSuggestions();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (this.suggestions.hidden) this.updateSuggestions();
          const count = this.suggestionOptions.length;
          if (!count) return;
          this.activeSuggestion = this.activeSuggestion < 0
            ? (event.key === 'ArrowDown' ? 0 : count - 1)
            : (this.activeSuggestion + (event.key === 'ArrowDown' ? 1 : count - 1)) % count;
          this.suggestions.querySelectorAll('[role="option"]').forEach((option, index) => {
            option.setAttribute('aria-selected', String(index === this.activeSuggestion));
          });
          const active = this.suggestions.children[this.activeSuggestion];
          this.search.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && !this.suggestions.hidden) {
          event.preventDefault();
          if (this.activeSuggestion >= 0) this.chooseSuggestion(this.activeSuggestion);
          else if (this.suggestionOptions.length === 1) this.chooseSuggestion(0);
          else this.closeSuggestions();
        }
      });
      this.closeSuggestions();
    }

    closeSuggestions() {
      if (!this.suggestions) return;
      this.suggestions.hidden = true;
      this.search.setAttribute('aria-expanded', 'false');
      this.search.removeAttribute('aria-activedescendant');
      this.activeSuggestion = -1;
    }

    updateSuggestions() {
      if (!this.suggestions) return;
      const query = this.search.value.toLowerCase().trim();
      this.clearButton.hidden = !this.search.value;
      if (!query && this.hasAttribute('data-lab-search-first')) {
        this.suggestionOptions = [];
        this.suggestions.replaceChildren();
        this.closeSuggestions();
        return;
      }
      this.suggestionOptions = this.groups
        .filter((group) => (group.dataset.product || '').toLowerCase().includes(query))
        .slice(0, 8)
        .map((group) => ({ label: group.dataset.product, product: group.dataset.product }));
      if (query && this.groups.some((group) => Array.from(group.querySelectorAll('[data-lab-item]')).some((item) => item.dataset.charge.includes(query)))) {
        this.suggestionOptions.push({ label: 'Charge „' + this.search.value.trim() + '“ suchen' });
      }
      this.suggestions.replaceChildren();
      this.suggestionOptions.forEach((option, index) => {
        const li = document.createElement('li');
        li.id = this.suggestions.id + '-' + index;
        li.dataset.index = index;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        const label = document.createElement('span');
        const match = option.label.toLowerCase().indexOf(query);
        if (query && match >= 0 && option.product) {
          label.append(option.label.slice(0, match));
          const mark = document.createElement('mark');
          mark.textContent = option.label.slice(match, match + query.length);
          label.append(mark, option.label.slice(match + query.length));
        } else label.textContent = option.label;
        li.append(label);
        this.suggestions.append(li);
      });
      this.activeSuggestion = -1;
      this.search.removeAttribute('aria-activedescendant');
      this.suggestions.hidden = this.suggestionOptions.length === 0;
      this.search.setAttribute('aria-expanded', String(!this.suggestions.hidden));
    }

    chooseSuggestion(index) {
      const option = this.suggestionOptions[index];
      if (!option) return;
      this.selectedProduct = option.product || '';
      if (option.product) this.search.value = option.product;
      this.render();
      this.search.focus();
      this.closeSuggestions();
    }

    initDropdown(dropdown) {
      const button = dropdown.querySelector('[data-lab-dropdown-button]');
      button?.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-lab-dropdown]').forEach((other) => this.closeDropdown(other));
        if (open) {
          button.setAttribute('aria-expanded', 'true');
          dropdown.querySelector('[data-lab-dropdown-list]')?.classList.add('visible');
        }
      });
      dropdown.querySelectorAll('[role="option"]').forEach((option) => {
        option.addEventListener('click', () => {
          this.select(dropdown, option);
          this.closeDropdown(dropdown);
          if (dropdown === this.product) this.updateSorteDropdown();
          this.render();
          button?.focus();
        });
      });
    }

    closeDropdown(dropdown) {
      dropdown.querySelector('[data-lab-dropdown-button]')?.setAttribute('aria-expanded', 'false');
      dropdown.querySelector('[data-lab-dropdown-list]')?.classList.remove('visible');
    }

    select(dropdown, option) {
      dropdown.dataset.value = option.dataset.value || '';
      const label = dropdown.querySelector('[data-lab-dropdown-label]');
      if (label) label.textContent = option.dataset.label || '';
      dropdown.querySelectorAll('[role="option"]').forEach((item) => {
        const selected = item === option;
        item.classList.toggle('qlf-bg-gray-200', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    updateSorteDropdown() {
      if (!this.sorte || !this.sorteField) return;
      const product = this.product?.dataset.value || '';
      let available = 0;
      this.sorte.querySelectorAll('[role="option"][data-product]').forEach((option) => {
        option.hidden = option.dataset.product !== product;
        if (!option.hidden) available++;
      });
      this.select(this.sorte, this.sorte.querySelector('[role="option"][data-value=""]'));
      this.sorteField.hidden = !product || available === 0;
      this.filters?.classList.toggle('has-sorte', !this.sorteField.hidden);
    }

    toggle(group, open) {
      group.querySelector('[data-lab-toggle]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
      group.querySelector('[data-lab-body]')?.classList.toggle('open', open);
    }

    render(preserveExpanded = false) {
      const query = this.selectedProduct ? '' : (this.search?.value || '').toLowerCase().trim();
      const product = this.selectedProduct || this.product?.dataset.value || '';
      const sorte = this.sorte?.dataset.value || '';
      const awaitingSearch = this.hasAttribute('data-lab-search-first') && !query && !product && !sorte;
      if (this.results) this.results.hidden = awaitingSearch;
      const filterKey = JSON.stringify([query, product, sorte]);
      if (!preserveExpanded || filterKey !== this.filterKey) {
        this.filterKey = filterKey;
        this.flavourLimits = new Map();
        this.chargeLimits = new Map();
        this.productLimit = 10;
      }
      let shown = 0;
      let matchingProducts = 0;
      let displayedProducts = 0;

      this.groups.forEach((group) => {
        const items = Array.from(group.querySelectorAll('[data-lab-item]'));
        const flavours = Array.from(group.querySelectorAll('[data-lab-flavour]'));
        const wasHidden = group.hidden;
        const loadFlavours = group.querySelector('[data-lab-load-flavours]');
        const flavourLimit = this.flavourLimits.get(group) || 5;
        const matchingItems = new Set();
        let visible = 0;
        let matches = 0;
        const matchingFlavours = new Set();
        items.forEach((item) => {
          const flavour = item.closest('[data-lab-flavour]');
          const flavourName = flavour?.dataset.sorte ?? group.dataset.sorte ?? '';
          const filterMatches = (!product || group.dataset.product === product) && (!sorte || flavourName === sorte);
          const groupMatches = query === '' || (group.dataset.search || '').includes(query) || flavourName.toLowerCase().includes(query);
          const match = filterMatches && (groupMatches || (item.dataset.charge || '').includes(query));
          if (match) {
            shown++;
            matches++;
            matchingItems.add(item);
            if (flavourName) matchingFlavours.add(flavourName);
          }
          item.hidden = !match;
        });
        let flavourMatches = 0;
        let displayedFlavours = 0;
        flavours.forEach((flavour) => {
          const hits = Array.from(flavour.querySelectorAll('[data-lab-item]')).filter((item) => matchingItems.has(item));
          const loadCharges = flavour.querySelector('[data-lab-load-charges]');
          const chargeLimit = this.chargeLimits.get(flavour) || 3;
          if (hits.length) flavourMatches++;
          flavour.hidden = !hits.length || (!!loadFlavours && displayedFlavours >= flavourLimit);
          if (!flavour.hidden) displayedFlavours++;
          hits.forEach((item, index) => {
            item.hidden = !!loadCharges && index >= chargeLimit;
            if (!flavour.hidden && !item.hidden) visible++;
          });
          if (loadCharges) {
            loadCharges.hidden = hits.length <= chargeLimit;
            const nextCount = Math.min(3, Math.max(0, hits.length - chargeLimit));
            loadCharges.textContent = nextCount === 1 ? 'Weitere Charge laden' : 'Weitere laden';
          }
        });
        if (!flavours.length) visible = matches;
        group.hidden = awaitingSearch || visible === 0 || (!!this.loadMoreProducts && displayedProducts >= this.productLimit);
        if (matches > 0) matchingProducts++;
        if (!group.hidden) displayedProducts++;
        const cnt = group.querySelector('[data-lab-cnt]');
        const flavourCount = matchingFlavours.size;
        if (cnt) cnt.textContent = flavours.length
          ? (flavourCount ? flavourCount + (flavourCount === 1 ? ' Sorte' : ' Sorten') + ' · ' : '') + matches + (matches === 1 ? ' Analyse' : ' Analysen')
          : '(' + matches + ')';
        if (loadFlavours) {
          loadFlavours.hidden = displayedFlavours >= flavourMatches;
          const nextCount = Math.min(5, flavourMatches - displayedFlavours);
          loadFlavours.textContent = nextCount === 1 ? 'Weitere Variante laden' : 'Weitere ' + nextCount + ' Varianten laden';
        }
        if (!preserveExpanded || wasHidden) {
          this.toggle(group, (query !== '' || sorte !== '' || product !== '') && visible > 0);
        }
      });

      if (this.loadMoreProducts) {
        this.loadMoreProducts.hidden = awaitingSearch || displayedProducts >= matchingProducts;
        const nextCount = Math.min(10, matchingProducts - displayedProducts);
        this.loadMoreProducts.textContent = nextCount === 1 ? 'Weiteres Produkt laden' : 'Weitere ' + nextCount + ' Produkte laden';
      }
      if (this.empty) {
        this.empty.hidden = awaitingSearch || shown > 0;
        this.empty.textContent = (this.dataset.emptyText || 'Nichts gefunden') + (query ? ' für „' + (this.search?.value || '').trim() + '“.' : '.');
      }
      const unit = shown === 1 ? this.dataset.unitOne : this.dataset.unitOther;
      const context = query || product || sorte ? 'gefunden' : 'insgesamt';
      const trustCount = this.querySelector('[data-lab-trust-count]');
      const trustContext = this.querySelector('[data-lab-trust-context]');
      if (trustCount) trustCount.textContent = shown + ' ' + unit;
      if (trustContext) trustContext.textContent = context;
      if (this.count) {
        this.count.hidden = !!trustCount;
        this.count.textContent = shown + ' ' + unit + ' ' + context;
      }
    }
  }

  customElements.define('qlf-lab-reports', QlfLabReports);
})();
